import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  LOCALE_ID,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AnalyticsService,
  BucketService,
  OrganisationService,
  SeoService,
  TRACKED_PAGES,
} from '@univacity/angular/datas';
import { DestroyAbleComponent } from '@univacity/angular/ui';
import { IMAGE_FORMAT, LOCALE, RoutePath, Tour } from '@univacity/shared/types';
import { StringUtil } from '@univacity/shared/util';
import { NzModalService } from 'ng-zorro-antd/modal';
import { takeUntil } from 'rxjs';
import { TourBookingSelectionComponent } from '../tour-booking-selection/tour-booking-selection.component';
import { TourDetailFooterComponent } from '../tour-detail-footer/tour-detail-footer.component';
import { TourHeaderComponent } from '../tour-header/tour-header.component';
import { TourHighlightComponent } from '../tour-highlight/tour-highlight.component';
import { TourInfoTabsComponent } from '../tour-info-tabs/tour-info-tabs.component';

@Component({
  selector: 'un-tour-detail-page',
  imports: [
    TourHeaderComponent,
    TourHighlightComponent,
    TourInfoTabsComponent,
    TourDetailFooterComponent,
  ],
  templateUrl: './tour-detail-page.component.html',
  styleUrls: ['./tour-detail-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TourDetailPageComponent
  extends DestroyAbleComponent
  implements OnInit
{
  tour: Tour;
  format = IMAGE_FORMAT.webp;
  routePath = RoutePath;
  constructor(
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private seo: SeoService,
    private analytics: AnalyticsService,
    private instituteSvc: OrganisationService,
    private bucketSvc: BucketService,
    private modal: NzModalService,
    @Inject(LOCALE_ID) public locale: LOCALE
  ) {
    super();
  }

  ngOnInit(): void {
    this.tour = this.route.snapshot.data['tour'];
    this.setupSeo();
    this.cdr.detectChanges();
  }

  private setupSeo() {
    if (!this.tour) return;
    const title = `${this.tour.name} (${StringUtil.toTitleCase(
      this.tour.theme
    )})`;
    this.instituteSvc
      .findOne(this.tour.organisation, { select: ['name', 'contact.website'] })
      .pipe(takeUntil(this.dead$))
      .subscribe((i) => {
        this.analytics.page(TRACKED_PAGES.tourDetail);
        this.seo.setPageTitle(title + ` - ${i.name}`);
      });
    this.seo.setFeatureImage(
      this.bucketSvc.getFullUrl(this.tour.coverPhoto, {
        format: IMAGE_FORMAT.png,
        width: 1080,
        height: 1080,
      }),
      {
        alt: this.tour.name + ' ' + $localize`Cover`,
        width: 1080,
        height: 1080,
      }
    );
    this.seo.setPageSeo(title, this.tour.excerpt);
    this.seo.addDates({
      createdAt: this.tour.createdAt,
      updatedAt: this.tour.updatedAt,
    });
  }

  book() {
    this.modal.create({
      nzContent: TourBookingSelectionComponent,
      nzData: {
        tour: this.tour,
      },
      nzTitle: $localize`${this.tour.name} - Booking`,
      nzFooter: null,
      nzMaskClosable: false,
    });
  }
}
